"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClonedSlug = exports.unSupportedClone = exports.updateSlugReferencesInFilePath = void 0;
exports.getClonedArtifactSlug = getClonedArtifactSlug;
const common_1 = require("@finley-technologies/common");
const updateSlugReferencesInFilePath = (oldToNewSlugMap, filePath) => {
    // this function is meant to update externalFilename or other strings that
    // represent filePaths, and may have slug references.
    // something like:
    // orgSlug/creditFacilitySlug/loanProductSlug/filenamexxx.pdf
    // to be safe we are only going to replace the slugs that are delimited by /
    const tokens = filePath.split('/');
    const newTokens = tokens.map((token) => oldToNewSlugMap.get(token) || token);
    const updated = newTokens.join('/');
    return updated;
};
exports.updateSlugReferencesInFilePath = updateSlugReferencesInFilePath;
const unSupportedClone = ({ artifactToClone, }) => {
    throw new Error(`Clone operation not implemented for [artifactType:${artifactToClone.type}]`);
};
exports.unSupportedClone = unSupportedClone;
function getClonedArtifactSlug(artifactSlug, cloneMap) {
    if (artifactSlug == null) {
        return artifactSlug;
    }
    let newSlug = artifactSlug;
    for (const [oldSlug, newMappedSlug] of cloneMap) {
        if (newSlug.includes(oldSlug)) {
            newSlug = newSlug.replaceAll(oldSlug, newMappedSlug);
        }
    }
    return newSlug;
}
// for some nodes lpSlug (or cfSlug) must be null
// for some nodes lpSlug (or cfSlug) must be string
// for some nodes lpSlug (or cfSlug) can be either
// this generic function takes care of these three variation,
// it returns the cloned version of the same type.
const getClonedSlug = (slug, cloneMap) => {
    if (slug === null) {
        // TypeScript cannot infer that null satisfies the complex conditional return type,
        // so we need to cast it. This is safe because when slug is null, we always return null
        // which matches the expected return type for T extends null case.
        return null;
    }
    const clonedSlug = cloneMap.get(slug);
    (0, common_1.finleyAssert)(clonedSlug !== undefined, `Slug mapping not found for: [slug:${slug}]`);
    // TypeScript cannot infer that clonedSlug (which is string) satisfies the complex
    // conditional return type. This is safe because clonedSlug is always a string when
    // slug is a string, which matches the expected return type for T extends string case.
    return clonedSlug;
};
exports.getClonedSlug = getClonedSlug;
//# sourceMappingURL=cloneUtils.js.map